// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5k-5";
export var imageContainer = "_5k-4";
export var metricsGrid = "_5k-2";
export var productDetailContainer = "_5k-1";
export var productListContainer = "_5k-0";
export var subscriberTableContainer = "_5k-3";